import React from 'react';
import { theme } from '../theme';
import { useMaintenanceMode } from '../contexts/MaintenanceContext';

interface AutoButtonProps {
  // Icon to render — wand (no action available) or page-specific action icon.
  icon: React.ReactNode;
  // Always invoked on click. Parent routes to the action or to an info-toast.
  onClick: () => void;
  title?: string;
}

// Icon-only square button. Always clickable — parent decides whether the click
// fires the action (when an action icon is supplied) or shows an info-toast
// (when the wand icon is supplied). Selection count is shown via SelectionStrip
// so the button stays compact and unambiguous.
// During maintenance mode the bulk action is the single highest-traffic write
// entry point, so it's disabled here; the long tail of writes is covered by the
// server-side 423 guard + the formatBackendError mapping.
export const AutoButton: React.FC<AutoButtonProps> = ({ icon, onClick, title }) => {
  const maintenance = useMaintenanceMode();
  return (
  <button
    onClick={onClick}
    disabled={maintenance}
    title={maintenance ? 'Wartungsarbeiten — Aktionen pausiert' : title}
    aria-label={maintenance ? 'Wartungsarbeiten — Aktionen pausiert' : title}
    style={{
      display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
      width: 40, height: 40, padding: 0,
      fontFamily: theme.font.family,
      color: theme.colors.white,
      backgroundColor: theme.colors.navy,
      border: 'none', borderRadius: theme.borderRadius.sm,
      cursor: maintenance ? 'not-allowed' : 'pointer',
      opacity: maintenance ? 0.5 : 1,
      transition: 'background 0.15s ease',
    }}
  >
    {icon}
  </button>
  );
};
